




























































































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { deviceServer, doublePrevention, spaceServe } from '@/api/installServer'; // 导入接口请求
import { Component, PropSync, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import TreeUnit from '@/components/tree/treeUnit.vue';
import BindDialog from '@/views/deviceInfo/unit/bindDialog.vue';
import AddDeviceDialog from '@/views/deviceInfo/unit/addDeviceDialog.vue';

@Component({
  components: { CollapseTransition, PagingUnit, TreeUnit, BindDialog, AddDeviceDialog },
  mixins: [TableStripe],
})
export default class DeviceInfoTable extends Vue {
  @PropSync('flag', Number) pageFlag!: number; // 显示哪个页面
  @PropSync('row', String) editRow!: string; // 向编辑页面传递的值
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  helpType = ''; // 详情、编辑
  total = 20; // 总共多少条数据
  page = 1; // 当前页数
  formShow = false; // 是否显示搜索表单内容
  obj: object = {}; // 搜索需要的对象
  // 表单数据对象
  formData: any = {
    deviceName: '', // 设备名称
    deviceCode: '', // 设备编号
    deptName: '', // 部门名称
    deviceStatusName: '', // 设备状态
    postName: '', // 岗位名称
    deviceManufacturer: '', // 设备制造商
    deviceFixedTypeName: '', // 固定资产分类
    isImportantDevice: null, // 是否重要设备
    isSpecialDevice: null, // 是否特种设备
    deviceModel: '', // 设备规格型号
  };
  // table 数据对象
  tableData: any[] = [];

  openAsideFlag = false; // 侧边栏是否打开
  $message: any;
  private deptList: any = [];
  private postList: any = [];
  private statusList: any = [];
  private fixedTypeList: any = [];
  private manufacturerList: any = [];
  private importantList: any = [
    {
      label: '是',
      value: true,
    },
    {
      label: '否',
      value: false,
    },
    {
      label: '',
      value: null,
    },
  ];
  private specialList: any = [
    {
      label: '是',
      value: true,
    },
    {
      label: '否',
      value: false,
    },
    {
      label: '',
      value: null,
    },
  ];

  private sycnList: any = [
    {
      label: '是',
      value: true,
    },
    {
      label: '否',
      value: false,
    },
    {
      label: '',
      value: null,
    },
  ];
  private helpTopDeptId: any = '';

  get orgList() {
    return this.$store.state.user.orgList;
  }

  orgIdToName(id: any) {
    const a: any = this.orgList.find((s: any) => {
      return s.spaceId === id;
    });
    let d: any = '';
    if (a) {
      d = a.name;
    }
    return d;
  }

  showTree(flag: boolean) {
    this.openAsideFlag = flag;
  }

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  async created() {
    // 调用获取全部数据方法
    // this.getAllData();
    await this.dataDoor();
    await this.getDeviceType('dept_name');
    await this.getDeviceType('post_name');
    await this.getDeviceType('device_status_name');
    await this.getDeviceType('device_fixed_type_name');
    await this.getDeviceType('device_manufacturer');
    await setTimeout(() => {
      this.findWorkshop();
    }, 500);
  }

  // 数据隔离
  dataDoor() {
    spaceServe.getTopDeptId().then((res: any) => {
      this.helpTopDeptId = res.data.value;
    });
  }

  /**
   *  如果顶级部门名称中含有"车间" ??? 改成 --->>> 走接口，如果 接口data.value 中含有 localStorage.topDeptId 则走下面的
   *  1. 区域筛选条件中 自动 勾选 含有对应的车间名称， 如 采矿车间 则 下拉自动勾选对应的 采矿车间
   *  2. 如果有符合的车间名称 ----> 带入车间id走查询的接口
   */
  findWorkshop() {
    this.formData.deptName = ''; // 部门名称
    const topDeptName: any = JSON.parse((localStorage as any).getItem('userInfo')).topDeptName;
    const topDeptId: any = JSON.parse((localStorage as any).getItem('userInfo')).topDeptId;
    // if (topDeptName.indexOf('车间') !== -1) { // 之前的判断条件
    if (this.helpTopDeptId.indexOf(topDeptId) !== -1) {
      // 1. 含有"车间"
      setTimeout(() => {
        this.deptList.forEach((item: any) => {
          // 2. 找到 含有车间且下拉列表中name和顶级车间名称相同的那项的id
          if (item === topDeptName) this.formData.deptName = item;
        });
        // 3. 刷新表格数据
        this.getAllData();
      }, 100);
    } else {
      this.getAllData();
    }
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getAllData() {
    // 发起接口请求，获取分页数据
    deviceServer
      .getDeviceInfoPage({
        ...this.formData,
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取设备数据失败');
      });
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏或查询按钮触发，隐藏或显示搜索表单内容。
   * @param1 暂无
   * @returns 暂无
   */
  isShowForm() {
    this.formShow = !this.formShow;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击新增按钮触发，跳转到新增岗位页面.
   * @param1 暂无
   * @returns 暂无
   */
  addProfession() {
    this.editRow = ''; // 传递id
    this.pageFlag = 3; // 进入新增页面
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    this.getAllData();
    // 搜索页和大小调回默认
    // (this.obj as any).name = (this.formData as any).name;
    // (this.obj as any).spaceCode = (this.formData as any).spaceCode;
    // (this.obj as any).enabled = (this.formData as any).enabled;
    // (this.queryDataForm as any).pageNo = 1;
    // deviceServer
    //   .getDeviceInfoPage({
    //     ...this.formData,
    //     current: (this.queryDataForm as any).pageNo,
    //     size: (this.queryDataForm as any).pageSize,
    //   })
    //   .then((res: any) => {
    //     this.tableData = res.data.records;
    //     this.total = res.data.total;
    //     this.$message.success('查询成功!');
    //   })
    //   .catch((error: any) => {
    //     this.$message.error('查询失败，请重试!');
    //   });
  }

  /**
   * @desc 点击重置按钮触发，重置搜索表单内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields();
    // 获取全部数据
    (this.queryDataForm as any).pageNo = 1;
    // this.obj = {}; // 点击重置，表单数据不参与请求
    this.getAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 函数描述
   * @param state - 模板状态 1-开始状态 2-结束状态
   * @returns 返回值描述
   */
  enterEdit(rowId: any, type: any) {
    this.helpType = type;
    this.$emit('on-response', this.helpType);
    this.editRow = rowId; // 给编辑页面传递需要修改的id
    this.pageFlag = 2; // 进入编辑页面
  }

  /**
   * @description 获取设备固定资产分类
   */
  getDeviceType(name: any) {
    deviceServer.getDeviceType(name).then((res: any) => {
      if (res.code == '200') {
        if (name === 'dept_name') {
          this.deptList = res.data;
        } else if (name === 'post_name') {
          this.postList = res.data;
        } else if (name === 'device_status_name') {
          this.statusList = res.data;
        } else if (name === 'device_fixed_type_name') {
          this.fixedTypeList = res.data;
        } else if (name === 'device_manufacturer') {
          this.manufacturerList = res.data;
        }
      }
    });
  }

  /**
   * @desc 绑定风险点、危险源
   */
  private bindDevice(id: any) {
    const BindDialog: any = this.$refs['bindDialog'];
    BindDialog.showDialog(id);
  }

  /**
   * @desc 删除 (sync === false 才可以删除，编辑，但是定位不受sync限制)
   */
  private deleteDevice(id: any) {
    this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        deviceServer.deleteDevice(id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('删除成功！');
            this.getAllData();
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }

  addDevice() {
    (this.$refs.addDeviceDialog as any).showDialog();
  }
}
